<template>
  <div class="view-product-register-module-lesson">
    <step-title :title="lessonTitle" />

    <div class="row">
      <div class="view-content-aside col-lg-3 pr-0 d-none d-lg-block">
        <steps
          class="pt-6 mt-3"
          :step="currentStep"
          :names="steps"
          @change-step="v => (currentStep = v)"
        />
      </div>

      <div class="col-lg-9 pl-6">
        <div v-if="currentStep === 1" v-show="nav === 'info'">
          <register-lesson-basic
            :product-id="$route.params.id"
            :form="form"
            :errors="errors"
            :lesson="lesson"
          />
        </div>
        <div v-if="currentStep === 2" v-show="nav === 'info'">
          <register-lesson-customization
            :form="form"
            :product-id="$route.params.id"
          />
        </div>

        <!-- <template v-if="$route.params.lesson">
          <comments-list
            v-show="nav === 'comments'"
            :lesson-id="$route.params.lesson"
          />
        </template> -->

        <div
          class="d-flex flex-column flex-md-row d-block justify-content-between mt-9 pb-5"
        >
          <button
            class="btn mb-5 btn-outline-secondary px-5 order-3 order-md-0"
            @click="back"
          >
            <span v-if="currentStep === 1">Cancelar</span>
            <span v-else class="d-flex align-items-center">
              <i class="icon-angle-left mr-6" />
              Voltar
            </span>
          </button>
          <div class="flex-fill"></div>
          <button
            class="btn btn-outline-secondary px-5 mb-5 mr-md-3 order-2 order-md-1"
            :disabled="!isValid"
            @click="saveAsDraft"
          >
            Salvar Rascunho
          </button>
          <button
            v-if="currentStep === 2"
            class="btn mb-5 mr-md-3 px-5 order-1 order-md-2"
            :class="
              isValid ? 'btn-new-outline-primary ' : 'btn-outline-secondary'
            "
            :disabled="!isValid"
            @click="next((createNew = true))"
          >
            <loading :show="loading && createNew">
              Salvar e criar novo
            </loading>
          </button>
          <button
            class="btn d-flex mb-5 align-items-center px-5 order-0 order-md-3"
            :class="isValid ? 'btn-primary ' : 'btn-secondary'"
            :disabled="!isValid"
            @click="next((createNew = false))"
          >
            <loading
              v-if="currentStep === steps.length"
              :show="loading && !createNew"
            >
              Salvar
            </loading>
            <span v-else class="d-flex align-items-center">
              Próximo
              <i class="icon-angle-right ml-6" />
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegisterLessonBasic from "@/components/product/details/content/RegisterLessonBasic";
import RegisterLessonCustomization from "@/components/product/details/content/RegisterLessonCustomization";
import { formFields, toComputerDate, toHumanDate } from "@/functions/helpers";
import MemberAreaMixin from "@/mixins/memberArea.js";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  mixins: [MemberAreaMixin],
  components: {
    RegisterLessonBasic,
    RegisterLessonCustomization
  },
  data() {
    return {
      currentStep: 1,
      steps: ["Informações básicas", "Personalização"],
      createNew: false,
      initial_extra_files: [],
      ...formFields(
        [
          "name",
          "link_media",
          "days_to_release",
          "meeting_password",
          "meeting_view_type",
          "release_at",
          "description",
          "duration",
          "extra_reading",
          "tags",
          "picture",
          "comments_enabled",
          "product_id",
          "module_id"
        ],
        {
          extra_reading: [],
          comments_enabled: true,
          meeting_password: "",
          meeting_view_type: "speaker",
          module_id: get(this.$route, "query.module_id", undefined)
        }
      ),
      modal: false,
      nav: "info",
      params: {
        product_id: this.$route.params.id,
        lesson_id: this.$route.params.lesson
      },
      navOptions: [
        { id: "info", name: "Conteúdo" },
        { id: "comments", name: "Comentários" }
      ]
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersLessons", ["lesson", "files"]),
    lessonTitle() {
      return this.$route.params?.lesson ? "Editando aula" : "Nova aula";
    },
    isValid() {
      return this.form.name && this.form.module_id;
    },
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        {
          link: "product-member-area-modules",
          title: "Conteúdo",
          params: { id: this.$route.params.id }
        },
        {
          title: !this.$route.params.lesson ? "Nova aula" : "Editando aula"
        }
      ];
    }
  },
  mounted() {
    if (this.$route.params.lesson) {
      this.loadInfo();
    }
  },
  methods: {
    loadInfo() {
      this.loading = true;
      this.$store
        .dispatch("membersLessons/getDetails", this.$route.params.lesson)
        .then(data => {
          this.form = {
            ...data,
            module_id: data.module.id,
            extra_reading: data.extra_reading || [],
            extra_files: data.extra_files || [],
            tags: data.tags || [],
            release_at: toHumanDate(data.release_at)
          };
          this.initial_extra_files = data.extra_files || [];
        })
        .finally(() => (this.loading = false));
    },
    async handleNewFiles(lesson_id) {
      const files_to_upload = get(this.form, "extra_files", []).filter(
        ({ id }) => !this.initial_extra_files.find(f => f.id == id)
      );
      if (files_to_upload.length) {
        try {
          await this.$store.dispatch("membersLessons/uploadFile", {
            files: files_to_upload,
            id: lesson_id
          });
        } catch (e) {
          const message =
            "Erro no upload dos arquivos, por favor tente novamente";
          throw new Error(message);
        }
      }
    },
    async handleRemovedFiles() {
      const files_to_remove = this.initial_extra_files.filter(
        ({ id }) => !get(this.form, "extra_files", []).find(f => f.id == id)
      );
      if (files_to_remove.length) {
        await Promise.all([
          ...files_to_remove.map(f =>
            this.$store.dispatch("membersLessons/deleteFile", f.id)
          )
        ]);
      }
    },
    async submit() {
      this.loading = true;

      const data = { ...this.form, product_id: this.params.product_id };
      let action = "membersLessons/post";

      if (this.params.lesson_id) {
        data.id = this.params.lesson_id;
        action = "membersLessons/put";
      }
      if (!this.form.days_to_release) {
        data.days_to_release = 0;
      }

      if (data.release_at) {
        data.release_at = toComputerDate(data.release_at);
      } else {
        data.release_at = null;
      }

      try {
        const response = await this.$store.dispatch(action, data);
        await this.handleNewFiles(response.data.id);
        await this.handleRemovedFiles();

        this.$message.success("Salvo com sucesso");

        if (this.createNew) {
          this.$router.go(0);
        } else {
          this.$router.go(-1);
        }
      } catch (error) {
        let msg = get(error, "message", get(error, "response.data", ""));
        // this.errors = error.message || error.response.data;
        this.$message.error(msg);
      } finally {
        this.loading = false;
      }
    },
    back() {
      if (this.currentStep === 1) {
        this.$router.go(-1);
      } else {
        this.currentStep--;
      }
    },
    saveAsDraft() {
      this.form.status = "draft";
      this.submit();
    },
    next() {
      if (this.currentStep === this.steps.length) {
        this.form.status = "published";
        this.submit();
      } else {
        this.currentStep++;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.view-product-register-module-lesson {
  .icon-angle-right,
  .icon-angle-left {
    font-size: 18px;
    margin-bottom: 1px;
    font-weight: 900;
  }
}
</style>
